








































import { Component, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateOpportunityLostReasonRequest from '@/models/Opportunities/CreateOpportunityLostReasonRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'OpportunityLostReasonCreate'
})
export default class extends GiganautVueDialog {

  public entity = new CreateOpportunityLostReasonRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateOpportunityLostReasonRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.createOpportunityLostReason(this.entity)
    this.dialog = false;
  }
}
